// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vz_a bhc_b bhc_wb"};